export default {
  CATEGORY_USER: 'User',
  CATEGORY_VENUE: 'Venue',
  CATEGORY_VENUE_WINE: 'VenueWine',
  CATEGORY_WINE: 'Wine',
  CATEGORY_REPORT: 'Report',
  CATEGORY_INVENTORY: 'Inventur',
  CATEGORY_RECEIPTS: 'Belege',

  ACTION_LOGIN: 'Login',
  ACTION_LOGOUT: 'Logout',

  ACTION_SHOW_ADD_PRODUCT: 'Öffne Produkt hinzufügen',

  ACTION_SEARCH: 'Suche',
  ACTION_SHOW_DETAILS: 'Öffne Details',

  ACTION_SHOW_SMART_LIST: 'Zeige Smartlist',
  ACTION_EDIT_SMART_LIST: 'Bearbeite Smartlist',
  ACTION_DELETE_SMART_LIST: 'Lösche Smartlist',

  ACTION_SHOW_PLAY_LIST: 'Zeige Playlist',
  ACTION_EDIT_PLAY_LIST: 'Bearbeite Playlist',
  ACTION_DELETE_PLAY_LIST: 'Lösche Playlist',

  ACTION_CREATE_PRODUCT: 'Erstelle Produkt',
  ACTION_EDIT_PRODUCT: 'Bearbeite Produkt',
  ACTION_UPDATE_PRODUCT: 'Aktualisiere Produkt',
  ACTION_DELETE_PRODUCT: 'Lösche Produkt',
  ACTION_MOVE_PRODUCT: 'Verschiebe Produkt',
  ACTION_REDUCE_PRODUCT: 'Reduziere Produkt',
  ACTION_DISCOUNT_PRODUCT: 'Rabattiere Produkt',

  ACTION_EDIT_MODE: 'Wechsle Edit Mode',
  ACTION_EDIT_AMOUNT: 'Bearbeite Menge',
  ACTION_EDIT_GLASS_AMOUNT: 'Bearbeite Glas Menge',

  ACTION_CREATE_PURCHASE_PRICE: 'Erstelle EK',
  ACTION_EDIT_PURCHASE_PRICE: 'Bearbeite EK',
  ACTION_DELETE_PURCHASE_PRICE: 'Lösche EK',

  ACTION_CREATE_SELLING_PRICE: 'Erstelle VK',
  ACTION_EDIT_SELLING_PRICE: 'Bearbeite VK',
  ACTION_DELETE_SELLING_PRICE: 'Lösche VK',

  ACTION_OPEN_REPORT_DETAIL: 'Öffne Report Detail',
  ACTION_CREATE_REPORT: 'Erstelle Report',
  ACTION_EDIT_REPORT: 'Bearbeite Report',
  ACTION_DELETE_REPORT: 'Lösche Report',
  ACTION_PRINT_REPORT: 'Drucke Report',
  ACTION_EXPORT_CSV: 'Exportiere CSV',

  ACTION_UPDATE_INVENTORY_PRODUCT: 'Aktualisiere Produkt',

  ACTION_SHOW_SETTINGS: 'Öffne Einstellungen',
  ACTION_SAVE_SETTINGS: 'Speichere Einstellungen',

  ACTION_CREATE_SUPPLIER: 'Erstelle Lieferant',
  ACTION_EDIT_SUPPLIER: 'Bearbeite Lieferant',
  ACTION_DELETE_SUPPLIER: 'Lösche Lieferant',

  LABEL_SUCCESS: 'Success',
  LABEL_FAILURE: 'Failure',


  trackEvent(category, action, name = null, value = null) {
    window._paq.push(['trackEvent', category, action, name, value]);
  },
  setCustomDimension(id, value) {
    window._paq.push(['setCustomDimension', id, value]);
  }
}